<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-0">
        {{ questionText }}
      </p>
      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing" class="mt-1 pl-6">
        <div v-for="option in options1" :key="option.value">
          <v-radio class="d-inline-block" :value="option.value">
            <template #label>
              <stemble-latex :content="option.text" />
            </template>
          </v-radio>
        </div>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'UPEISafety7',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        input1: null,
      },
    };
  },
  computed: {
    questionNumber() {
      return this.taskState.getValueBySymbol('questionNumber').content;
    },
    questionText() {
      if (this.questionNumber.value === 1) {
        return 'Who does safety begin with?';
      } else if (this.questionNumber.value === 2) {
        return 'Who should you inform immediately if any type of incident occurs?';
      } else {
        return 'Which types of incidents should you report to your instructor?';
      }
    },
    options1() {
      if (this.questionNumber.value === 1) {
        return [
          {text: 'The instructor', value: '1'},
          {text: 'Your fellow students', value: '2'},
          {text: 'You', value: '3'},
          {text: 'No one', value: '4'},
        ];
      } else if (this.questionNumber.value === 2) {
        return [
          {text: 'The instructor', value: '1'},
          {text: 'Your lab partner', value: '2'},
          {text: 'No one', value: '3'},
          {text: 'Your mom', value: '4'},
        ];
      } else {
        return [
          {text: 'Chemical spills and splashes', value: '1'},
          {text: 'Burns and fires', value: '2'},
          {text: 'Cuts', value: '3'},
          {text: 'All of the above', value: '4'},
        ];
      }
    },
  },
};
</script>
